import { render, staticRenderFns } from "./StoneList.vue?vue&type=template&id=1171fb1d&scoped=true&"
import script from "./StoneList.vue?vue&type=script&lang=js&"
export * from "./StoneList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1171fb1d",
  null
  
)

export default component.exports